import { ObraEditora } from '@/views/obras/types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isObjetoVazio = (obj: any): boolean => {
  return !obj || Object.keys(obj).length === 0;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const onKeyDownPreventNonNumbers = (event: any) => {
  const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
  const isAllowedKey =
    allowedKeys.includes(event.key) || (event.ctrlKey && event.key === 'v');
  const isNumber = /^\d+$/.test(event.key);
  if (!isAllowedKey && !isNumber) {
    event.preventDefault();
  }
};

export const onKeyDownPreventNonNumericRange = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  event: any,
  minValue: number,
  maxValue: number
) => {
  const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
  const isAllowedKey =
    allowedKeys.includes(event.key) || (event.ctrlKey && event.key === 'v');
  const isNumber = /^\d+$/.test(event.key);

  if (!isAllowedKey && !isNumber) {
    event.preventDefault();
  }

  const inputValue = Number(event.target.value + event.key);
  if (inputValue < minValue || inputValue > maxValue) {
    event.preventDefault();
  }
};

export const processarAno = (ano: number): string | null => {
  if (!ano) return null;

  if (ano < 0 || ano > 2090) {
    throw new Error('Informe um ano correto.');
  }

  const dia = new Date().getDate();
  const mes = new Date().getMonth();

  const anoFormatado = ano < 50 ? `20${ano}` : ano < 100 ? `19${ano}` : ano;

  return new Date(Number(anoFormatado), mes, dia, 12, 0).toISOString();
};

export const formatarPublicacoes = (data: ObraEditora[] = []) => {
  return data.map(
    ({ local, nmEditora, anoPublicacao }) =>
      `${local ?? ''} : ${nmEditora ?? ''}, ${anoPublicacao ?? ''}`
  );
};
